// extracted by mini-css-extract-plugin
export default {"range":"styles_range__ATGRU","icon":"styles_icon__aQQT5"};